import { StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getAccountInvoiceDetailsTabStyles(theme: Theme) {
  return StyleSheet.create({
    cardWrap: {
      alignSelf: 'stretch',
      gap: 20,
      paddingVertical: theme.spacing.lg,
      paddingHorizontal: theme.spacing.lg,
      borderRadius: theme.borderRadius.lg,
      borderWidth: 1,
      borderColor: theme.gray[300],
      backgroundColor: theme.background.card,
    },
    container: {
      gap: 20,
    },
  })
}
